// Module
var code = "<a href=\"mailto:{{ $ctrl.emailAddress }}\" ng-click=\"$event.stopPropagation()\"> <i class=\"fas fa-envelope\"></i> </a> ";
// Exports
module.exports = code;